import UserModel from '../../../../UserModel';
import { CYCLE_ACTIVE_ROUTE, CYCLE_DETAILS_ROUTE } from '../../../modules/cycleCount/consts';
import { PRODUCTS_DETAILS_ROUTE } from '../../../modules/products/consts';

export default {
    name: 'waveDetailsPage',
    before: [],
    after: ['cycleCount'],
    setup: (app) => {
        const routeName = 'cycleCountWaveDetails';
        const route = app.routes.getItem(routeName);

        if (route) {
            const routeProps = route.props;
            route.props = (state) => ({
                ...routeProps(state),
                permissions: {
                    canAssignUser: UserModel.getCurrentUser().hasAnyPermissions('cycle-counts.assign user'),
                    canUnassignUser: UserModel.getCurrentUser().hasAnyPermissions('cycle-counts.assign user'),
                    canStartWave: UserModel.getCurrentUser().hasAnyPermissions('cycle-counts.start wave'),
                    canCountItems: UserModel.getCurrentUser().hasAnyPermissions('cycle-counts.count item'),
                    canCancelCycleCount: UserModel.getCurrentUser().hasAnyPermissions('cycle-counts.details'),
                    withProductDetailsPage: true,
                },
                routes: {
                    cycleCountGridPageRoute: CYCLE_ACTIVE_ROUTE,
                    cycleCountDetailsPageRoute: CYCLE_DETAILS_ROUTE,
                    productDetailsPageRoute: PRODUCTS_DETAILS_ROUTE,
                },
            });

            route.loader = () => import('./packages/WaveDetails/core');
            app.routes.changeItem(routeName, route);
        }
    },
};
